<div>
    <!-- #createUpdateForm -->
    <settings-financial-line-item-form-component
        (savePressed)="savePressedEventHandler($event)"
        [data]="data.financialLineItem"
        [languages]="languages"
    >
    </settings-financial-line-item-form-component>
    <p *ngIf="nameAlreadyExistsError" class="error">
        {{ 'aumico_settings_financialLineItem_form_name_already_exists_error' | i18next  }}
    </p>
</div>
